import { Map, Record } from "immutable";
import { RootState, RootActions } from "common/reducers";
import { receive } from "common/reducers/Utils";
import { calendarFromJSON, CalendarRecord } from "common/records/Calendar";
import { RECEIVE_CALENDAR, RECEIVE_CALENDARS, RECEIVE_CRONOFY_URL } from "common/reducers/calendar.actions";

export const CalendarStateRecord = Record({
  byId: Map<number, CalendarRecord>(),
  lastSavedById: Map<number, CalendarRecord>(),
  cronofyUrl: "",
});

export const initialState = CalendarStateRecord();
export type CalendarState = typeof initialState;

const model = "calendars";

export const calendarReducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.getIn([model])) {
    state = state.setIn([model], initialState);
  }
  switch (action.type) {
    case RECEIVE_CALENDAR:
      return receive(state, model, calendarFromJSON(action.payload.calendar));

    case RECEIVE_CALENDARS:
      action.payload.calendars.forEach((calendar) => {
        state = receive(state, model, calendarFromJSON(calendar));
      });

      return state;

    case RECEIVE_CRONOFY_URL:
      return state.setIn([model, "cronofyUrl"], action.payload.url);

    default:
      return state;
  }
};
